import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { NewPasswordField } from "./components/NewPasswordField/NewPasswordField.js";
import { RepeatPasswordField } from "./components/RepeatPasswordField/RepeatPasswordField.js";
import { ResetPasswordFooter } from "./components/ResetPasswordFooter/ResetPasswordFooter.js";
import { TextsProvider } from "./contexts/texts.js";
import { useAutoFocusEmptyField } from "./hooks/useAutoFocusEmptyField.js";
import { resetPasswordForm, resetPasswordFormInitialValues } from "./resetPasswordFormSetup.js";
function ResetPasswordForm(props) {
  const {
    mode = "single-password",
    testId = "reset-password-form-root",
    texts,
    verbose,
    initialValues,
    validationSummaryItems,
    onInitialize,
    className,
    sx,
    onFormApi,
    onSubmit,
    customSlot,
    componentProps,
    fieldProps,
    autoFocus,
    ...tidalFormProps
  } = props;
  const rNotifyWrongConfig = useRef(true);
  useEffect(() => {
    if (!rNotifyWrongConfig.current) return;
    if (!onInitialize) return;
    if (!initialValues) return;
    rNotifyWrongConfig.current = false;
    console.warn(
      "[Login Form] `onInitialize` and `initialValues` are mutually exclusive. `initialValues` will be ignored."
    );
  }, [onInitialize, initialValues]);
  const [firstSubmitDone, setFirstSubmitDone] = useState(false);
  const showRepeatPassword = mode === "repeat-password";
  return /* @__PURE__ */ jsx(TextsProvider, { texts, children: /* @__PURE__ */ jsx(
    resetPasswordForm.Form,
    {
      disableScroll: true,
      fieldsPadding: 0,
      fieldsSpacing: 2,
      sx,
      className,
      ...tidalFormProps,
      testId,
      footer: /* @__PURE__ */ jsx(
        ResetPasswordFooter,
        {
          autoFocus,
          showRepeatPassword,
          mode,
          buttonProps: {
            ...componentProps?.submitButton,
            ...fieldProps?.submitButton
          },
          silentErrors: !firstSubmitDone,
          validationSummaryItems
        }
      ),
      onFormApi,
      onInitialize: () => {
        if (onInitialize) {
          return onInitialize();
        }
        return {
          initialValues: Object.assign({}, resetPasswordFormInitialValues, initialValues)
        };
      },
      onSubmit: async (formState, formValues, api, formEvent) => {
        await onSubmit(formState);
      },
      children: /* @__PURE__ */ jsx(ResetPasswordFormFields, { ...props, firstSubmitDone })
    }
  ) });
}
function ResetPasswordFormFields(props) {
  const {
    autoFocus,
    firstSubmitDone,
    mode = "single-password",
    passwordVisible,
    customSlot,
    componentProps,
    fieldProps
  } = props;
  const errorVisibility = firstSubmitDone ? "accent-only" : "none";
  const passwordVisibility = passwordVisible ? "show" : "hide";
  const showRepeatPassword = mode === "repeat-password";
  const autoFocusField = useAutoFocusEmptyField(autoFocus, showRepeatPassword);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      NewPasswordField,
      {
        autoFocusField,
        componentProps: componentProps?.newPassword,
        fieldProps: fieldProps?.newPassword,
        errorVisibility,
        defaultPasswordVisibility: passwordVisibility
      }
    ),
    showRepeatPassword && /* @__PURE__ */ jsx(
      RepeatPasswordField,
      {
        autoFocusField,
        componentProps: componentProps?.repeatPassword,
        fieldProps: fieldProps?.repeatPassword,
        errorVisibility,
        defaultPasswordVisibility: passwordVisibility
      }
    ),
    customSlot
  ] });
}
export {
  ResetPasswordForm
};
//# sourceMappingURL=ResetPasswordForm.js.map
